module.exports = __webpack_public_path__ + "files/d05495017c465a184416c95c914023b7.png";